<template>
  <section id="screenshots" class="screenshots">
    <div class="screenshots-container">
      <div class="section-header">
        <div class="section-badge">📸 场景演示</div>
        <h2 class="section-title">老板键的艺术</h2>
        <p class="section-description">
          一个按键，两种状态，从容应对每一个突发时刻
        </p>
      </div>

      <div class="story-timeline">
        <div 
          v-for="(screenshot, index) in screenshots" 
          :key="index"
          class="story-card"
          :style="{ animationDelay: `${index * 0.15}s` }"
        >
          <div class="story-number">{{ index + 1 }}</div>
          <div class="screenshot-image">
            <img :src="screenshot.image" :alt="screenshot.title" />
          </div>
          <div class="story-content">
            <h3>{{ screenshot.title }}</h3>
            <p>{{ screenshot.description }}</p>
          </div>
        </div>
      </div>

      <div class="story-summary">
        <div class="summary-card">
          <div class="summary-icon">⚡</div>
          <h3>这就是 Double Enter 的智慧</h3>
          <p>500毫秒内连按两次回车键，工作与私密空间瞬间切换。无论是处理私密文件、学习充电，还是短暂放松，都能从容应对突发情况。让隐私保护变得优雅而自然。</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ScreenshotsSection',
  data() {
    return {
      screenshots: [
        {
          image: require('@/assets/宣传图/1.png'),
          title: '第一幕：危机降临',
          description: '工作间隙，正在浏览学习资料放松片刻。突然，上司的脚步声由远及近。千钧一发之际，轻轻双击回车键...'
        },
        {
          image: require('@/assets/宣传图/2.png'),
          title: '第二幕：完美切换',
          description: '上司带着怀疑的目光走近屏幕。但此刻，界面已经无缝切换至工作状态，代码编辑器、项目文档一应俱全，专注工作的形象展露无遗。'
        },
        {
          image: require('@/assets/宣传图/3.png'),
          title: '第三幕：获得认可',
          description: '上司看到屏幕上密密麻麻的代码，满意地点了点头，竖起大拇指："很好，继续保持！"危机化解，从容应对。'
        },
        {
          image: require('@/assets/宣传图/4.png'),
          title: '第四幕：自由切换',
          description: '上司转身离去，再次双击回车键。熟悉的界面重新出现，工作与休息自如切换。这就是 Double Enter，您的隐私守护专家。'
        }
      ]
    }
  }
}
</script>

<style scoped>
.screenshots {
  padding: 100px 20px;
  background: linear-gradient(180deg, #f8f9ff 0%, #ffffff 100%);
}

.screenshots-container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-badge {
  display: inline-block;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 8px 20px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 20px;
  animation: fadeIn 1s ease-out;
}

.section-title {
  font-size: 42px;
  font-weight: 800;
  color: #333;
  margin-bottom: 15px;
  animation: fadeInUp 1s ease-out 0.1s both;
}

.section-description {
  font-size: 18px;
  color: #666;
  animation: fadeInUp 1s ease-out 0.2s both;
}

.screenshots-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.story-timeline {
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-bottom: 60px;
  position: relative;
}

.story-timeline::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
  transform: translateX(-50%);
  border-radius: 2px;
}

.story-card {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
  animation: fadeInUp 1s ease-out both;
  position: relative;
  z-index: 1;
}

.story-card:nth-child(even) {
  direction: rtl;
}

.story-card:nth-child(even) > * {
  direction: ltr;
}

.story-number {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 700;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
  z-index: 2;
  border: 5px solid white;
}

.screenshot-card {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  animation: fadeInUp 1s ease-out both;
}

.screenshot-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 60px rgba(102, 126, 234, 0.15);
}

.screenshot-image {
  height: auto;
  min-height: 300px;
  overflow: hidden;
  background: #f5f5f5;
  position: relative;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.screenshot-image img {
  width: 100%;
  height: auto;
  object-fit: contain;
  transition: transform 0.3s ease;
  display: block;
}

.screenshot-card:hover .screenshot-image img {
  transform: scale(1.05);
}

.story-card:hover .screenshot-image {
  box-shadow: 0 15px 40px rgba(102, 126, 234, 0.2);
}

.story-card:hover .screenshot-image img {
  transform: scale(1.05);
}

.story-content {
  padding: 20px;
}

.story-content h3 {
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin-bottom: 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.story-content p {
  font-size: 16px;
  color: #666;
  line-height: 1.8;
}

.story-summary {
  margin-top: 60px;
  animation: fadeInUp 1s ease-out 0.6s both;
}

.summary-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  padding: 50px;
  text-align: center;
  color: white;
  box-shadow: 0 20px 60px rgba(102, 126, 234, 0.3);
}

.summary-icon {
  font-size: 64px;
  margin-bottom: 20px;
  animation: pulse 2s ease-in-out infinite;
}

.summary-card h3 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 15px;
}

.summary-card p {
  font-size: 18px;
  line-height: 1.8;
  opacity: 0.95;
  max-width: 800px;
  margin: 0 auto;
}

.screenshot-info {
  padding: 25px;
}

.screenshot-info h3 {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin-bottom: 10px;
}

.screenshot-info p {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .screenshots {
    padding: 60px 20px;
  }

  .section-title {
    font-size: 32px;
  }

  .section-description {
    font-size: 16px;
  }

  .story-timeline::before {
    left: 30px;
  }

  .story-card {
    grid-template-columns: 1fr;
    gap: 20px;
    padding-left: 80px;
  }

  .story-card:nth-child(even) {
    direction: ltr;
  }

  .story-number {
    left: 30px;
    width: 50px;
    height: 50px;
    font-size: 24px;
  }

  .screenshot-image {
    height: auto;
    min-height: 200px;
  }

  .story-content {
    padding: 10px 0;
  }

  .story-content h3 {
    font-size: 20px;
  }

  .story-content p {
    font-size: 14px;
  }

  .summary-card {
    padding: 30px 20px;
  }

  .summary-icon {
    font-size: 48px;
  }

  .summary-card h3 {
    font-size: 22px;
  }

  .summary-card p {
    font-size: 16px;
  }

  .screenshots-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
</style>
